import { Col, Container, Row } from 'react-bootstrap';
import differenceBetweenDates from '../../../../utils/differenceBetweenDates';
import { ChildrenAtScheduleFromApiType } from '../../types';
import { KidsContainer, KidsGroup } from './styles';

interface KidsListInterface {
  list: ChildrenAtScheduleFromApiType[];
}

export default function KidsList({ list }: KidsListInterface) {
  return (
    <KidsContainer>
      <Container>
        <Row xs={1} md={2} lg={2}>
          {list.map((child) => (
            <Col key={`${child.name}${Math.random()}`}>
              <KidsGroup>
                <div className="info">
                  <div className="card-title">
                    <strong>{child.name}</strong>
                    {child.birthDate && (
                      <small>{`${differenceBetweenDates(child.birthDate).years} anos`}</small>
                    )}
                  </div>
                  <span>
                    Responsável:
                    {' '}
                    {child.responsavel}
                  </span>
                  <span>
                    {child.hasDeficiency ? '⚠️' : ''} Observação:
                    {' '}
                    {child.observation || 'Sem observação'}
                  </span>
                </div>
              </KidsGroup>
            </Col>
          ))}
        </Row>
      </Container>
    </KidsContainer>
  );
}
